module.exports = __webpack_public_path__ + "assets/img/_Novo Show Unit_Living Room_RGB_lr.64d51ca2.jpg";